var gql = require("@apollo/client").gql;

const PROVIDERS_LIST_QUERY = gql`
	query PROVIDERS_LIST_QUERY(
		$filter: String
		$aggregateFilter: String
		$limit: Int!
		$offset: Int!
		$sort: String
		$random: Boolean
	) {
		providers(filter: $filter, limit: $limit, offset: $offset, sort: $sort, random: $random) {
			pagination {
				items_count
				items_total
				per_page
				page_current
				page_total
			}
			data {
				id
				name
				url_name
				translit_name
				logo
				sell_self {
					provider {
						id
						name
						logo
						url_name
						region {
							url
						}
					}
				}
				region {
					id
					name
					url
				}
				rating {
					expert {
						final
					}
					order_types {
						position
						order_type_id
						review_all
						in_main_rating
					}
				}
				order_types {
					id
					name
				}
				dody {
					name
					full_description
					short_description
				}
				info {
					cnt_tariffs
					min_price
					max_speed
				}
				vip_provider
				vip_provider_b2b
				vip_provider_b2b_link
				vip_provider_b2b_sat
				vip_provider_b2b_sat_link
				vip_b2c_priority
			}
		}
		providersAggregate: providers(filter: $aggregateFilter, limit: $limit, with_aggregate: 1) {
			aggregation {
				providers {
					id
					name
					translit_name
				}
				order_types {
					id
					name
				}
				dody {
					global_id
					name
				}
			}
		}
	}
`;

export default PROVIDERS_LIST_QUERY;
